module.exports = __webpack_public_path__ + "static/analyzing_emotional_discourse-1edb8372d1db328ce80f2c668441d5cc.png";